export default class DM1FaultsConstants {
  constructor() {
    this.listFMIname = [
      'Above Normal Range, Most Severe Level',
      'Below Normal Range, Most Severe Level',
      'Erratic, Intermittent or Incorrect (rationality)',
      'Voltage Above Normal or Shorted High',
      'Voltage Below Normal, or Shorted to Ground',
      'Current Below Normal, or Open Circuit',
      'Current Above Normal, or Grounded Circuit',
      'Mechanical System not Responding or Out of Adjustment',
      'Abnormal Frequency or Pulse Width or Period',
      'Abnormal Update Rate',
      'Abnormal Rate of Change',
      'Failure Code not Identifiable',
      'Bad Intelligent Device or Component',
      'Out of Calibration',
      'Special Instructions',
      'Above Normal Range : Least Severe Level',
      'Above Normal Range: Moderately Severe Level',
      'Below Normal Range: Least Severe Level',
      'Below Normal Range: Moderately Severe Level',
      'Received Network Data in Error: (Multiplexed Data)',
      'Data Drifted High (rationality high)',
      'Data Drifted Low (rationality low)',
      'reserved (22)',
      'reserved (23)',
      'reserved (24)',
      'reserved (25)',
      'reserved (26)',
      'reserved (27)',
      'reserved (28)',
      'reserved (29)',
      'reserved (30)',
      'Condition Exists',
    ];

    this.listSourceAddress = [
      'Engine #1',
      'Engine #2',
      'Turbocharger',
      'Transmission #1',
      'Transmission #2',
      'Shift Console - Primary',
      'Shift Console - Secondary',
      'Power TakeOff - (Main or Rear)',
      'Axle - Steering',
      'Axle - Drive #1',
      'Axle - Drive #2',
      'Brakes - System Controller',
      'Brakes - Steer Axle',
      'Brakes - Drive axle #1',
      'Brakes - Drive Axle #2',
      'Retarder - Engine',
      'Retarder - Driveline',
      'Cruise Control',
      'Fuel System',
      'Steering Controller',
      'Suspension - Steer Axle',
      'Suspension - Drive Axle #1',
      'Suspension - Drive Axle #2',
      'Instrument Cluster #1',
      'Trip Recorder',
      'Passenger-Operator Climate Control #1',
      'Alternator/Electrical Charging System',
      'Aerodynamic Control',
      'Vehicle Navigation',
      'Vehicle Security',
      'Electrical System',
      'Starter System',
      'Tractor-Trailer Bridge #1',
      'Body Controller',
      'Auxiliary Valve Control or Engine Air System Valve Control',
      'Hitch Control',
      'Power TakeOff (Front or Secondary)',
      'Off Vehicle Gateway',
      'Virtual Terminal (in cab)',
      'Management Computer #1',
      'Cab Display #1',
      'Retarder, Exhaust, Engine #1',
      'Headway Controller',
      'On-Board Diagnostic Unit',
      'Retarder, Exhaust, Engine #2',
      'Endurance Braking System',
      'Hydraulic Pump Controller',
      'Suspension - System Controller #1',
      'Pneumatic - System Controller',
      'Cab Controller - Primary',
      'Cab Controller - Secondary',
      'Tire Pressure Controller',
      'Ignition Control Module #1',
      'Ignition Control Module #2',
      'Seat Control #1',
      'Lighting - Operator Controls',
      'Rear Axle Steering Controller #1',
      'Water Pump Controller',
      'Passenger-Operator Climate Control #2',
      'Transmission Display - Primary',
      'Transmission Display - Secondary',
      'Exhaust Emission Controller',
      'Vehicle Dynamic Stability Controller',
      'Oil Sensor',
      'Suspension - System Controller #2',
      'Information System Controller #1',
      'Ramp Control',
      'Clutch/Converter Unit',
      'Auxiliary Heater #1',
      'Auxiliary Heater #2',
      'Engine Valve Controller',
      'Chassis Controller #1',
      'Chassis Controller #2',
      'Propulsion Battery Charger',
      'Communications Unit, Cellular',
      'Communications Unit, Satellite',
      'Communications Unit, Radio',
      'Steering Column Unit',
      'Fan Drive Controller',
      'Seat Control #2',
      'Parking brake controller',
      'Aftertreatment #1 system gas intake',
      'Aftertreatment #1 system gas outlet',
      'Safety Restraint System',
      'Cab Display #2',
      'Diesel Particulate Filter Controller',
      'Aftertreatment #2 system gas intake',
      'Aftertreatment #2 system gas outlet',
      'Safety Restraint System #2',
      'Atmospheric Sensor',
      'Powertrain Control Module',
      'Power Systems Manager',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Manufacturer Reserved SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'Unknown SA',
      'File Server / Printer',
      'Off Board Diagnostic-Service Tool #1',
      'Off Board Diagnostic-Service Tool #2',
      'On-Board Data Logger',
      'Reserved for Experimental Use',
      'Reserved for OEM',
      'Null Address',
      'GLOBAL (All-Any Node)',
    ];
  }
}
